var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import { EVMVaultList, TreasuryVaultList, VaultVersionList, } from "../constants/constants";
export var ERC20TokenList = __spreadArray(__spreadArray([
    "weth",
    "usdc",
    "usdc.e",
    "wbtc",
    "wbnb",
    "yvusdc",
    "steth",
    "reth",
    "wsteth",
    "ldo",
    "aave",
    "rbn",
    "verbn",
    "wavax",
    "savax",
    "perp"
], VaultVersionList.flatMap(function (version) {
    return EVMVaultList.map(function (option) { return option + "-" + version; });
})), VaultVersionList.flatMap(function (version) {
    return TreasuryVaultList.map(function (option) { return option + "-" + version; });
}));
export var getERC20TokenNameFromVault = function (vault, version) {
    return vault + "-" + version;
};
export var getERC20TokenDecimals = function (asset) {
    switch (asset) {
        case "usdc":
        case "yvusdc":
            return 6;
        case "wbtc":
            return 8;
        default:
            return 18;
    }
};
export var getERC20TokenDisplay = function (asset) {
    switch (asset) {
        case "yvusdc":
            return "yvUSDC";
        case "steth":
            return "stETH";
        case "verbn":
            return "veRBN";
        default:
            return asset.toUpperCase();
    }
};
//# sourceMappingURL=eth.js.map